<template>
  <div class="insight">
    <card :has-footer-padding="false" :has-header-padding="false">
      <template v-slot:header>
        <lottie-player v-if="animationName"
                       :class="backgroundVariant"
                       :src="JSON.stringify(require(`@/assets/animations/${animationName}`))" :autoplay="true" :loop="loop"/>
        <img class="top-image" v-if="imageName" :src="require(`@/assets/insights/${imageName}`)"/>
      </template>
      <div class="insight-body">
        <div class="insight-text">
          <slot name="insight-text"/>
        </div>
        <riseup-button class="riseup-button"
                       :action="buttonAction"
                       :size="'slim'"
                       :title="buttonText"
                       :variant="'primary'"/>
      </div>
    </card>
  </div>
</template>

<script>
import '@lottiefiles/lottie-player';
import BaseUI from 'base-ui';
import Segment from '@/Segment';

export default {
  name: 'Insight',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Card: BaseUI.Card,
  },
  props: {
    insight: { type: Object },
    animationName: { type: String },
    imageName: { type: String },
    buttonText: { type: String },
    buttonAction: { type: Function },
    backgroundVariant: {
      type: String,
      validator: val => ['red'].includes(val),
      required: false,
    },
    loop: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    Segment.trackUserGot('InsightLoaded', this.insight);
  },
};

</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '@/scss/mixins';
  .insight {
    @include responsive-padding;
    padding-top: 30px;
    padding-bottom: 17px;
    background-color: $riseup_gray_-1;
    display: flex;
    justify-content: center;
    width: 100%;

    // The lottie player is a shadow node so we cannot override it's css. It uses grid-inline so we need to move it with relative position
    lottie-player {
      position: relative;
      top: -3px;

      &.red{
        background: $expense_red1;
      }
    }
    .top-image {
      width: 100%;
    }
    .insight-body {
      margin-top: 12px;
      font-family: SimplerPro;
      direction: rtl;
      padding-bottom: 25px;

      .insight-text {
        display: flex;
        align-items: center;
        min-height: 60px;
        font-size: 20px;
        line-height: 26px;
      }

      .riseup-button {
        width: 100%;
        margin-top: 16px;
      }
    }
  }
</style>
